import React from "react";
import GenericB2BList, { B2B_TYPES } from "../B2B/GenericB2BList";
import B2BCouponGiftModal from "../../../Components/modal/B2BCouponGiftModal";

/**
 * B2B Coupon List - uses GenericB2BList with coupon configuration
 */
function B2BCouponList({ todayOnly }) {
  return (
    <GenericB2BList
      type={B2B_TYPES.COUPON}
      GiftModalComponent={B2BCouponGiftModal}
      todayOnly={todayOnly}
    />
  );
}

export default B2BCouponList;
